import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message, Popconfirm } from 'antd';
import { theme } from 'utils/style/theme';
import { fetchProjectList } from 'apis/common/commonApis';
import {
  fetchBgmDropList,
  fetchSeDropList,
  soundManagementList,
  soundManagementUpdate,
} from 'apis/platform/soundApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import GrayBox from 'components/container/GrayBox';
import DefaultSelect from 'components/select/DefaultSelect';
import VerticalTable from 'components/table/VerticalTable';
import SubmitButton from 'components/button/SubmitButton';
import { useCookies } from 'react-cookie';

/**
 *
 * @returns {시스템 사운드 목록}
 */
const SystemSoundListPage = () => {
  const [cookies] = useCookies();
  const [datas, setDatas] = useState();
  const [bgmDropList, setBgmDropList] = useState();
  const [seDropList, setSeDropList] = useState();
  const [projectDropList, setProjectDropList] = useState();
  const [bgmUrl, setBgmUrl] = useState();
  console.log(bgmUrl);
  console.log(datas);

  const handleSeChange = (text, url) => (e) => {
    const arr = seDropList && seDropList.filter((v) => v.sound_id === e);
    // console.log(arr[0]);
    setDatas({ ...datas, [text]: e, [url]: arr[0].sound_url });
  };

  const handleMainBgmChange = (e) => {
    const arr = bgmDropList && bgmDropList.filter((v) => v.sound_id === e);
    console.log(arr);
    setDatas({ ...datas, main_bgm_sound_id: e });
    setBgmUrl(arr[0].sound_url);
  };

  const handleChangeProject = async (e) => {
    const bgmRes = await fetchBgmDropList(e);
    bgmRes.map((v, i) => {
      v.text = v.sound_name;
      v.value = v.sound_id;
    });
    setDatas({ ...datas, main_bgm_project_id: e, main_bgm_sound_id: null });
    setBgmDropList(bgmRes);
  };

  const handleSubmit = async () => {
    console.log(datas);
    const res = await soundManagementUpdate(datas);
    if (res !== false) {
      message.success('사운드가 성공적으로 변경되었습니다. ', 1);
    }
  };

  const fetchDropData = async (projectId) => {
    const projectRes = await fetchProjectList();
    setProjectDropList(projectRes);
  };

  const fetchData = async (data) => {
    const res = await soundManagementList();
    setDatas(res[0]);

    const bgmRes = await fetchBgmDropList(res[0].main_bgm_project_id);
    bgmRes.map((v, i) => {
      v.text = v.sound_name;
      v.value = v.sound_id;
    });
    setBgmDropList(bgmRes);

    //sound url변경
    const arr = bgmRes.filter((v) => v.sound_id === res[0].main_bgm_sound_id);
    setBgmUrl(arr[0].sound_url);

    const seRes = await fetchSeDropList();
    seRes.map((v, i) => {
      v.text = v.sound_name;
      v.value = v.sound_id;
    });
    setSeDropList(seRes);
  };

  useEffect(() => {
    fetchData().catch(console.log);
    fetchDropData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <p></p>
        <Popconfirm title='수정하시겠습니까?' onConfirm={handleSubmit}>
          <SubmitButton disabled={JSON.parse(cookies.platformAuth)}>
            수정하기
          </SubmitButton>
        </Popconfirm>
      </TableToolbar>
      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          메인 BGM
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>작품이름</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={projectDropList}
                  value={datas && datas.main_bgm_project_id}
                  onChange={handleChangeProject}
                />
              </td>
            </tr>
            <tr>
              <th>배경 음악</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={bgmDropList}
                  value={datas && datas.main_bgm_sound_id}
                  placeholder='메인 BGM을 선택해주세요'
                  onChange={handleMainBgmChange}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={bgmUrl && bgmUrl} />
          </VerticalTable>
        </div>
      </GrayBox>

      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          긍정 sfx
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>효과음</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={seDropList}
                  value={datas && datas.positive_sound_id}
                  onChange={handleSeChange(
                    'positive_sound_id',
                    'positive_sound_url',
                  )}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={datas && datas.positive_sound_url} />
          </VerticalTable>
        </div>
      </GrayBox>

      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          부정 sfx
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>효과음</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={seDropList}
                  onChange={handleSeChange(
                    'negative_sound_id',
                    'negative_sound_url',
                  )}
                  value={datas && datas.negative_sound_id}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={datas && datas.negative_sound_url} />
          </VerticalTable>
        </div>
      </GrayBox>

      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          재화(보상) 획득 sfx
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>효과음</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={seDropList}
                  onChange={handleSeChange('claim_sound_id', 'claim_sound_url')}
                  value={datas && datas.claim_sound_id}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={datas && datas.claim_sound_url} />
          </VerticalTable>
        </div>
      </GrayBox>

      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          경험치 상승 sfx
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>효과음</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={seDropList}
                  onChange={handleSeChange(
                    'exp_up_sound_id',
                    'exp_up_sound_url',
                  )}
                  value={datas && datas.exp_up_sound_id}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={datas && datas.exp_up_sound_url} />
          </VerticalTable>
        </div>
      </GrayBox>

      <GrayBox
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <h2 className='title' style={{ width: '20rem' }}>
          등급업 sfx
        </h2>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <VerticalTable>
            <tr>
              <th>효과음</th>
              <td>
                <DefaultSelect
                  style={{ width: '20rem' }}
                  optionList={seDropList}
                  onChange={handleSeChange(
                    'grade_up_sound_id',
                    'grade_up_sound_url',
                  )}
                  value={datas && datas.grade_up_sound_id}
                />
              </td>
            </tr>
          </VerticalTable>
          <VerticalTable>
            <audio controls src={datas && datas.grade_up_sound_url} />
          </VerticalTable>
        </div>
      </GrayBox>

      {/* 수정 모달 */}
    </DefaultLayout>
  );
};

export default SystemSoundListPage;
const LeftTitle = styled.div`
  display: flex;
  width: 50%;
  /* border: solid 2px blue; */
  justify-content: space-between;
  .mainTitle {
    /* border: solid 2px blue; */
    margin-left: 20px;
    font-weight: 700;
    color: ${theme.colors.blueText};
    margin-top: 4px;
  }
  .flex {
    display: flex;
    /* border: solid 2px yellow; */
    margin-right: 50px;
    height: 0%;
    align-items: center;
    justify-content: center;
    p {
      font-weight: 700;
    }
  }
`;
const RightContent = styled.div`
  width: 100%;
  /* border: solid 2px pink; */
  display: flex;
  select {
    width: 200px;
  }
  .left {
    display: flex;
  }
  .leftFlex {
    display: flex;
    /* border: solid 2px pink; */
    margin: 5px 0;
    height: 100%;
    align-items: center;
  }
  .title {
    margin-right: 20px;
    font-weight: 700;
    width: 80px;
  }
  .alert {
    position: relative;
    left: 0px;
  }
  span {
    /* border: solid 2px black; */
  }
  > div {
    /* border: solid 2px red; */
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  > div {
  }
`;

const SoundWrap = styled.div`
  margin-right: 100px;
  width: 80%;
  height: 100%;
  .filepond--root {
    height: 50%;
    width: 100%;
  }
`;
